import React from 'react';
import classes from './Error.module.css';
import { useNavigate } from 'react-router-dom';

const Error = () => {
    const navigate = useNavigate();
    const goToHomePage = () => {
        navigate('/');
    }

    return (
        <div>
            {/* <Nav></Nav>
        <MobileNav></MobileNav> */}

            <div className={classes.error}>
                <h1>404</h1>
                <h2>Oops! Page Not Found</h2>
                <p>The page you're looking for migh be renamed, removed or might never exists on this planet.</p>
                <button onClick={goToHomePage}>Go Back to Home Page</button>
            </div>
        </div>
    )
}

export default Error;